<template>
  <view class="m-row" :style="rowStyle">
    <slot></slot>
  </view>
</template>

<script setup>
import { computed, provide } from 'vue';

const props = defineProps({
  // 支持 Number, String, Array
  gutter: {
    type: [Number, String, Array],
    default: 0
  }
});

// 解析各种格式的 gutter
const parseGutter = (val) => {
  let x = 0, y = 0;
  if (Array.isArray(val)) {
    x = Number(val[0]) || 0;
    y = Number(val[1]) || 0;
  } else {
    x = Number(val) || 0;
    y = x;
  }
  return { x, y };
};

// 将解析后的 gutter 传递给子组件
provide('rowGutter', computed(() => parseGutter(props.gutter)));

// Row 的负 margin 抵消 Col 的 padding
const rowStyle = computed(() => {
  const { x, y } = parseGutter(props.gutter);
  return {
    marginLeft: `-${x / 2}px`,
    marginRight: `-${x / 2}px`,
    marginTop: `-${y / 2}px`,
    marginBottom: `-${y / 2}px`
  };
});
</script>

<style lang="less" scoped>
.m-row {
  display: flex;
  flex-wrap: wrap;
  box-sizing: border-box;
}
</style>